import type { ReactNode } from 'react';
import ProductThumbnail from '../../app/components/ProductThumbnail';
import type { ProductDetails } from '../../app/models/Product';

type Props = {
    product: Pick<ProductDetails, 'title' | 'featuredImage' | 'sku' | 'vendor' | 'totalFitmentCount' | 'uniqueFitmentCount' | 'productLevelFitmentCount' | 'variants' | 'isAtdProduct'> | null;
    isUniversal: boolean;
    adminUrl: string;
    status?: string;
    children?: ReactNode;
};

const SummaryField = ({ label, children }: { label: string; children: ReactNode }) => (
    <s-stack gap="small-300">
        <s-text color="subdued">{label}</s-text>
        <s-text>{children}</s-text>
    </s-stack>
);

export default function ProductSummaryCard({ product, isUniversal, adminUrl, status, children }: Props) {
    const fitments = !product
        ? '…'
        : isUniversal
            ? 'Universal'
            : (product.uniqueFitmentCount ?? 0).toLocaleString();

    return (
        <s-section accessibilityLabel="Product summary">
            <s-stack gap="base">
                <s-query-container>
                    <s-grid gridTemplateColumns="@container (inline-size > 640px) auto 1fr 1fr 1fr 1fr auto, auto 1fr" gap="large" alignItems="center">
                        <ProductThumbnail source={product?.featuredImage} alt={product?.title ?? 'Product'} size="medium" />
                        <SummaryField label="SKU">{product?.sku || '—'}</SummaryField>
                        <SummaryField label="Vendor">{product?.vendor || '—'}{product?.isAtdProduct ? ' · ATD synced' : ''}</SummaryField>
                        <SummaryField label="Status">{status || '—'}</SummaryField>
                        <SummaryField label="Fitments">{fitments}</SummaryField>
                        {adminUrl && (
                            <s-button href={adminUrl} target="_blank" icon="external">
                                Shopify admin
                            </s-button>
                        )}
                    </s-grid>
                </s-query-container>
                {children && <><s-divider />{children}</>}
            </s-stack>
        </s-section>
    );
}
